"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12.995 6.616c0-.587.406-1.063.906-1.063h8.155c.499 0 .905.476.905 1.063v.272h-9.966v-.272Zm0 14.05h9.966V7.927h-9.966v12.737Zm0 1.037h9.966v.273c0 .49-.311.985-.905.985H13.9c-.5 0-.906-.478-.906-1.065v-.193ZM15.563 0c1.127 0 2.022.846 2.097 1.95l.006.153v1.583c0 .306-.213.52-.52.52a.494.494 0 0 1-.512-.421l-.007-.099V2.103c0-.529-.433-.997-.952-1.057l-.112-.007H2.103c-.529 0-.998.433-1.058.952l-.006.112v19.793c0 .53.433.999.951 1.059l.113.006H12c.105 0 .194.032.272.078a2.21 2.21 0 0 1-.31-.964l-.006-.179V6.616c0-1.107.794-2.017 1.8-2.097l.145-.006h8.155c1.022 0 1.864.86 1.938 1.946l.006.157v15.36c0 1.102-.762 1.945-1.795 2.019l-.15.005h-8.154a1.873 1.873 0 0 1-1.406-.657c.01.044.025.086.025.137 0 .272-.17.471-.422.512L12 24H2.103a2.079 2.079 0 0 1-2.098-1.95L0 21.896V2.103C0 .975.845.081 1.95.005L2.103 0h13.46ZM8.186 21.25a.92.92 0 0 1 1.295 0 .92.92 0 0 1 0 1.296.912.912 0 0 1-.647.266.914.914 0 0 1-.648-.266.92.92 0 0 1 0-1.296Zm7.377-19.666c.272 0 .471.17.512.422l.008.098v1.583c0 .307-.213.52-.52.52-.273 0-.471-.168-.512-.421l-.008-.099V2.623H2.623v17.171h8.19c.305 0 .52.214.52.52 0 .271-.17.47-.422.511l-.098.008h-8.71a.493.493 0 0 1-.512-.421l-.007-.099V2.103c0-.272.169-.471.421-.512l.099-.008h13.459Zm3.167 4.118h-.791a.521.521 0 0 0-.521.52.52.52 0 0 0 .52.519h.792a.52.52 0 0 0 .52-.52.521.521 0 0 0-.52-.52Z",
    clipRule: "evenodd"
  })]
});